import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import { TicketData } from '@/common/types/support/ticket.type'
import { UserRoundIcon } from 'lucide-react'

type SupportTicketUserProps = {
  user: TicketData['creator'] | TicketData['responsible']
}

export const SupportTicketUser = ({ user }: SupportTicketUserProps) => {
  return (
    <ImageWithDisplayName
      imageUrl={user?.profile_picture?.url}
      displayName={user?.full_name}
      placeholderIcon={UserRoundIcon}
      imageClassName="size-6"
      iconClassName="size-4"
    />
  )
}
